import { useCallback, useRef, useState } from 'react';
export const useMutation = (mutationFn, options = {}) => {
    const [state, setState] = useState('UNINITIALIZED');
    const [recentMutation, setRecentMutation] = useState(false);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    // Use refs to avoid stale closures in the memoized callbacks
    const mutationFnRef = useRef(mutationFn);
    const optionsRef = useRef(options);
    mutationFnRef.current = mutationFn;
    optionsRef.current = options;
    const reset = useCallback(() => {
        setState('UNINITIALIZED');
        setRecentMutation(false);
        setError(null);
        setData(null);
    }, []);
    const mutate = useCallback(async (...args) => {
        setState('LOADING');
        setError(null);
        try {
            const data = await mutationFnRef.current(...args);
            setData(data);
            setState('SUCCESS');
            if (optionsRef.current.onSuccess) {
                optionsRef.current.onSuccess(data, ...args);
            }
            setRecentMutation(true);
            setTimeout(() => {
                setRecentMutation(false);
            }, 2000);
        }
        catch (err) {
            setError(err);
            setState('ERROR');
            if (optionsRef.current.onError) {
                optionsRef.current.onError(err, ...args);
            }
        }
        finally {
            if (optionsRef.current.onSettled) {
                optionsRef.current.onSettled(...args);
            }
        }
    }, []);
    return {
        isLoading: state === 'LOADING',
        isSuccess: state === 'SUCCESS',
        isInitialized: state !== 'UNINITIALIZED',
        isError: state === 'ERROR',
        status: state,
        recentMutation,
        data,
        error,
        reset,
        mutate,
    };
};
//# sourceMappingURL=hooks.js.map